import type { PackageDirectionType } from '@/features/package/domain/enums/PackageDirectionType'
import type { PackageItemType } from '@/features/package/domain/enums/PackageItemType'
import type { PackageStatus } from '@/features/package/domain/enums/PackageStatus'
import type { VehicleTemplateType } from '@/features/vehicleTemplate/domain/enums/VehicleTemplateType'

export class LivePackageEntity {
  id?: string
  userId?: string
  userDisplayName?: string | null
  serviceId?: number
  serviceName?: string | null
  status?: PackageStatus
  statusUpdatedAt?: string
  deliveryFeePrice?: number
  senderName?: string | null
  senderPhoneNumber?: string | null
  receiverName?: string | null
  receiverPhoneNumber?: string | null
  directionType?: PackageDirectionType
  vehicleTemplateType?: VehicleTemplateType | null
  itemType?: PackageItemType
  referenceCode?: string | null
  createdAt?: string
  trackingPanelUserId?: string | null
  trackingPanelUserDisplayName?: string | null
  userPhoneNumber?: string | null
  assignedDriver?: AssignedDriverEntity
}

export class AssignedDriverEntity {
  id?: number
  workingPhoneNumber?: string | null
  fullName?: string | null
  avatarImagePath?: string | null
}
